import { render, staticRenderFns } from "./ProfileAttentionFinished.vue?vue&type=template&id=492d11d2&scoped=true&"
import script from "./ProfileAttentionFinished.vue?vue&type=script&lang=js&"
export * from "./ProfileAttentionFinished.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAttentionFinished.vue?vue&type=style&index=0&id=492d11d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d11d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('492d11d2', component.options)
    } else {
      api.reload('492d11d2', component.options)
    }
    module.hot.accept("./ProfileAttentionFinished.vue?vue&type=template&id=492d11d2&scoped=true&", function () {
      api.rerender('492d11d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/attention_finished/ProfileAttentionFinished.vue"
export default component.exports